export default function ThreeStepSystem() {
  const steps = [
    {
      number: '1',
      title: 'Akıllı Reklam Kurulumu',
      description: 'İşinize özel reklam stratejisi ve yapay zeka destekli geri dönüş algoritması kurulur.',
      icon: 'ri-brain-line',
      color: 'from-blue-500 to-blue-600'
    },
    {
      number: '2',
      title: '7/24 Müşteri İşleme Sistemi',
      description: 'Facebook, Instagram ve WhatsApp üzerinden gelen tüm mesajlar anında işlenir ve potansiyel müşteriye dönüştürülür.',
      icon: 'ri-customer-service-2-line',
      color: 'from-yellow-500 to-yellow-600'
    },
    {
      number: '3',
      title: 'Akıllı Panel ve Veri Geri Bildirimi',
      description: 'En çok müşteri getiren kitleler otomatik analiz edilir ve reklamlar sürekli optimize edilir.',
      icon: 'ri-dashboard-line',
      color: 'from-red-500 to-red-600'
    }
  ];

  return (
    <section className="py-20 px-4 sm:px-6 lg:px-8 relative">
      <div className="absolute inset-0 bg-gradient-to-b from-black via-gray-900 to-black"></div>
      
      <div className="relative z-10 max-w-7xl mx-auto">
        {/* Section Title */}
        <div className="text-center mb-16">
          <h2 className="text-4xl sm:text-5xl font-bold text-white mb-4">
            Smart Hizmet <span className="bg-gradient-to-r from-yellow-500 to-yellow-600 bg-clip-text text-transparent">3 Aşamalı Sistem</span>
          </h2>
        </div>

        {/* Steps Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {steps.map((step, index) => (
            <div 
              key={index}
              className="group relative bg-gradient-to-br from-gray-900 to-black border border-white/10 rounded-2xl p-8 hover:border-yellow-500/50 transition-all duration-500 hover:shadow-2xl hover:shadow-yellow-500/20 hover:-translate-y-2"
            >
              {/* Step Number */}
              <div className={`absolute -top-6 -left-6 w-16 h-16 bg-gradient-to-br ${step.color} rounded-full flex items-center justify-center text-2xl font-bold text-white shadow-lg`}>
                {step.number}
              </div>

              {/* Icon */}
              <div className="mb-6 flex justify-center">
                <div className={`w-20 h-20 bg-gradient-to-br ${step.color} rounded-full flex items-center justify-center group-hover:scale-110 transition-transform duration-300`}>
                  <i className={`${step.icon} text-4xl text-white`}></i>
                </div>
              </div>

              {/* Content */}
              <h3 className="text-2xl font-bold text-white mb-4 text-center">
                {step.title}
              </h3>
              <p className="text-gray-400 text-center leading-relaxed">
                {step.description}
              </p>

              {/* Decorative Element */}
              <div className="absolute bottom-0 left-0 right-0 h-1 bg-gradient-to-r from-transparent via-yellow-500/50 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
